<template>
  <div>
    <v-layout row wrap>
      <v-flex>
        <v-dialog v-model="snackbar" width="500">
          <v-card>
            <v-card-title class="headline teal darken-4 white--text" primary-title>{{snacktext}}</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" text @click="snackbar = false">close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs1 md1>
        <v-btn class="my-1 ml-3" small fab dark :color="getThemeColor" fixed>
          <v-icon @click="goBack()">mdi-backburger</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs1 md1>
        <v-btn
          class="my-1"
          small
          fab
          dark
          :color="getThemeColor"
          fixed
          @click="saveSlidesAndPreview()"
        >
          <v-icon dark>mdi-content-save-all</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs1 md1>
        <v-btn class="my-1" small fab dark :color="getThemeColor" fixed>
          <v-icon @click="addContent('MathComponent')">mdi-sigma</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs1 md1>
        <v-btn class="my-1" small fab dark :color="getThemeColor" fixed>
          <v-icon @click="addContent('FreeHandWithFabric')">mdi-gesture-double-tap</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs1 md1>
        <v-btn class="my-1" small fab dark :color="getThemeColor" fixed>
          <v-icon @click="addContent('ThreeColumnCard')">mdi-view-column</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs1 md1>
        <v-btn class="my-1" small fab dark :color="getThemeColor" fixed>
          <v-icon @click="addContent('OneColumnImage')">mdi-image-area</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs1 md1>
        <v-btn class="my-1" small fab dark :color="getThemeColor" fixed>
          <v-icon @click="addContent('ImageCard')">mdi-book-open</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs1 md1>
        <v-btn class="my-1" small fab dark :color="getThemeColor" fixed>
          <v-icon @click="addContent('ThreeColumnImage')">mdi-folder-multiple-image</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs1 md1>
        <v-btn class="my-1" small fab dark :color="getThemeColor" fixed>
          <v-icon @click="addContent('HeaderComponent')">mdi-signal-hspa-plus</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs1 md1>
        <v-btn class="my-1" small fab dark :color="getThemeColor" fixed>
          <v-icon @click="addContent('EditableParagraph')">mdi-format-text</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs1 md1>
        <v-btn class="my-1" small fab dark :color="getThemeColor" fixed>
          <v-icon @click="addContent('ListComponent')">mdi-format-list-bulleted</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <br />

    <v-layout row wrap class="mt-5">
      <!-- <v-flex>
        <carousel :per-page="1" :navigate-to="someLocalProperty" :mouse-drag="false">
          <slide
            v-for="(component,cIndex) in getComponents"
            :key="cIndex+Math.random()+Math.random()"
          >
            <v-btn class="my-3" right x-small fab dark color="red" fixed>
              <v-icon @click="removeCurrentComponent(cIndex)">mdi-delete-forever</v-icon>
            </v-btn>
            <v-sheet color="black" height="100%">
              <v-row class="fill-height" align="center" justify="center">
                <component
                  :is="component.name"
                  :key="cIndex+Math.random()+Math.random()"
                  :index="cIndex"
                  :content="component.content"
                ></component>
              </v-row>
            </v-sheet>
          </slide>
        </carousel>
      </v-flex>-->
      <v-flex xs12 md2>
        <v-timeline dense v-if="getComponents.length > 0">
          <v-timeline-item
            v-for="(component,cIndex) in getComponents"
            :key="cIndex+Math.random()+Math.random()"
            :color="getThemeColor"
          >
            <v-btn
              rounded
              outlined
              @click="goToCurrentSlide(cIndex)"
              :color="getThemeColor"
              dark
            >Slide {{cIndex+1}}</v-btn>
          </v-timeline-item>
        </v-timeline>
      </v-flex>
      <Loader />
      <v-flex xs12 md9>
        <v-btn class="my-3" right x-small fab dark color="red" fixed>
          <v-icon @click="removeCurrentComponent(currentSlide)">mdi-delete-forever</v-icon>
        </v-btn>
        <div class="slide-items">
          <component
            v-if="getComponents.length > 0"
            :is="getComponents[currentSlide]['name']"
            :key="currentSlide+Math.random()+Math.random()"
            :index="currentSlide"
            :content=" getComponents[currentSlide]['name'] == 'FreeHandWithFabric' ? getComponents[currentSlide]['imgData'] : getComponents[currentSlide]['content']"
          ></component>
        </div>
      </v-flex>

      <!-- <v-flex>
        <v-carousel :show-arrows="true" height="1000">
          <v-carousel-item
            v-for="(component,cIndex) in getComponents"
            :key="cIndex+Math.random()+Math.random()"
          >
            <v-btn class="my-3" right x-small fab dark color="red" fixed>
              <v-icon @click="removeCurrentComponent(cIndex)">mdi-delete-forever</v-icon>
            </v-btn>
            <div class="slide-items">
              <component
                :is="component.name"
                :key="cIndex+Math.random()+Math.random()"
                :index="cIndex"
                :content=" component.name == 'FreeHandWithFabric' ? component.imgData :component.content"
              ></component>
            </div>
          </v-carousel-item>
        </v-carousel>
      </v-flex>-->

      <!-- <v-flex
        class="mx-4"
        v-for="(component,cIndex) in getComponents"
        :key="cIndex+Math.random()+Math.random()"
      >
        <v-btn class="my-3" right x-small fab dark color="red" fixed>
          <v-icon @click="removeCurrentComponent(cIndex)">mdi-delete-forever</v-icon>
        </v-btn>
        <div class="slide-items">
          <component :is="component.name" :index="cIndex" :content="component.content"></component>
        </div>
      </v-flex>-->
    </v-layout>
  </div>
</template>

<script>

import Loader from "../components/Loader.vue";
import Toolbar from "@/components/myLibrary/Toolbar";
import axios from "@/plugins/axios";
import { Carousel, Slide } from "vue-carousel";
import HeaderComponent from "../components/CreateSlideParts/HeaderComponent.vue";
import EditableParagraph from "../components/CreateSlideParts/EditableParagraph.vue";
import ListComponent from "../components/CreateSlideParts/ListComponent.vue";
import ImageCard from "../components/CreateSlideParts/ImageCard.vue";
import ThreeColumnCard from "../components/CreateSlideParts/ThreeColumnCard.vue";
import ThreeColumnImage from "../components/CreateSlideParts/ThreeColumnImage.vue";
import OneColumnImage from "../components/CreateSlideParts/OneColumnImage.vue";
import MathComponent from "../components/CreateSlideParts/MathComponent.vue";
import FreeHandWithFabric from "../components/CreateSlideParts/FreeHandWithFabric.vue";

export default {
  components: {
    HeaderComponent,
    EditableParagraph,
    ListComponent,
    ImageCard,
    Toolbar,
    ThreeColumnCard,
    ThreeColumnImage,
    OneColumnImage,
    MathComponent,
    Carousel,
    Slide,
    FreeHandWithFabric,
    Loader
  },
  mounted() {
    this.lesson = this.$route.params;
    this.$store.commit("setLoader", true);
    axios
      .postDataWithToken(
        "/auth/get-slides-from-db",
        { lessonId: this.$route.params.lesson_id },
        this.getAccessToken
      )
      .then(response => {
        this.$store.commit("initializeComponents", response);
        this.currentSlide = 0;
        this.$store.commit("setLoader", false);
      });
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getComponents() {
      return this.$store.getters.getComponents;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    }
  },
  data() {
    return {
      dialog: false,
      lesson: null,
      snackbar: false,
      snacktext: null,
      currentSlide: null
    };
  },

  methods: {
    addContent(compString) {
      this.$store.commit("pushToComponents", {
        name: compString,
        id: "",
        content: "",
        lessonId: this.lesson.lesson_id,
        arrayIndex: this.getComponents.length,
        lessonOutcomes: this.lesson.lesson_plan,
        lessonName: this.lesson.name,
        userId: this.getCurrentUser.id
      });
      this.currentSlide = this.getComponents.length - 1;
    },
    goToCurrentSlide(cIndex) {
      this.currentSlide = cIndex;
    },
    removeCurrentComponent(cIndex) {
      const component = this.getComponents[cIndex];
      if (component.id == "") {
        this.$store.commit("sliceComponent", cIndex);
        this.snacktext = "Slides Successfully Deleted! ";
        this.snackbar = true;
        if (this.getComponents.length > 0) {
          if (cIndex == 0) {
            this.currentSlide = 1;
          } else {
            this.currentSlide = this.getComponents.length - 1;
          }
        }
      } else {
        axios
          .postDataWithToken(
            "/auth/remove-component-from-db",
            { componentId: component.id },
            this.getAccessToken
          )
          .then(response => {
            if (response.status <= 200) {
              this.$store.commit("sliceComponent", cIndex);
              this.snacktext = "Slides Successfully Deleted! ";
              this.snackbar = true;
              if (this.getComponents.length > 0) {
                if (cIndex == 0) {
                  this.currentSlide = 1;
                } else {
                  this.currentSlide = this.getComponents.length - 1;
                }
              }
            } else {
              this.snacktext = "Oops, something went wrong! ";
              this.snackbar = true;
            }
          });
      }
    },
    goBack() {
      this.$router.back();
    },

    saveSlidesAndPreview() {
      axios
        .postDataWithToken(
          "/auth/save-slides",
          { components: this.getComponents },
          this.getAccessToken
        )
        .then(response => {
          if (response.status > 200) {
            this.snacktext = "Oops, something went wrong! ";
            this.snackbar = true;
          } else {
            this.snacktext = "Slides Saved Successfully! ";
            this.snackbar = true;
          }
        });
    }
  }
};
</script>
